<app-petitum-form *ngIf="petitum" [petitum]="petitum"
                  (onValidForm)="onValidPetitum($event)" 
                  (onUpdatePetitum) = "retrievePetitum($event)"
                  [suggested] = "entities && entities.length > 0"
></app-petitum-form>

<div class="row wizard-buttons">
  <p class="col-sm-3 col-xs-6">
    <button type="button" class="btn btn-outline-secondary btn-block" (click)="onReset()">Reset</button>
  </p>
  <p class="col-sm-3 col-xs-6 col-sm-offset-6">
    <button type='button' class='btn btn-primary btn-block' [disabled]="!isContinueEnabled" (click)="onContinue()">
      Prosegui
    </button>
  </p>
</div>

